import React, { useEffect, useState } from "react";
import { Typography, Row, Col, Card, Button, Collapse, Switch, InputNumber, Modal } from "antd";
import {
  CheckOutlined,
  TagFilled,
  FireOutlined,
  UpOutlined,
  DownOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import { PLAN_DETAIL_MODALS, BUNDLE_DETAIL_MODALS } from "../../data/data";
import "./WhatYouGet.scss";
import { CALENDLY_LINK, PORTAL_BASE_URL } from "../../../../env";
import ModelViewer from "../../../landingPage/sectionTwo/modelViewer";


const WhatYouGet = (props) => {
  const [selectedData, setSelectedData] = useState(null);
  const findBundleByTitle = (title) => {
    let data = PLAN_DETAIL_MODALS;
    if (props.selectedPlan != "subscriptions") {
      data = BUNDLE_DETAIL_MODALS;
    }

    return data.find(bundle => bundle.title === title);
  };

  const closeModal = () => {
    props.setSelectedOffer('');
  }

  useEffect(() => {
    console.log(props.selectedOffer)
    setSelectedData(findBundleByTitle(props.selectedOffer))
  }, [props.selectedOffer])

  const clickAndRedirect = () => {
    if (selectedData?.button_text === 'Schedule a Demo') {
      window.open(CALENDLY_LINK, '_blank')
    }
    else if (props.selectedPlan == "subscriptions") {
      window.open(`${PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(`/select-subscription?plan=${selectedData.plan_plus_name ? selectedData.plan_plus_name : selectedData.plan_name}&plan_type=subscription`)}`, '_blank')
    } else {
      window.open(`${PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(`/select-subscription?plan=${selectedData.name}&plan_type=bundle&quantity=${props.quantity[selectedData.title] || 1}`)}`, '_blank')
    }
  }

  return (<Modal
    onCancel={closeModal}
    visible={props.selectedOffer != ''}
    className="what-you-get-modal"
    footer={[
      <div className="justify-space-between">
        <div className="manrope f-12 w-400 lh-20 black-085 upgrade-text-alignment">
          {selectedData?.upgrade_text}
        </div>
        <div className={"justify-in-end"}>
          <Button className="modal-okay-black-outline square font-14" onClick={closeModal}>
            Close
          </Button>
          <Button className="modal-okay square font-14" onClick={clickAndRedirect}>
            {selectedData?.button_text}
          </Button>
        </div>
      </div>
    ]}>
    <Row>
      <Col span={24}>
        <p className="manrope f-14 w-500 black-085">What You Get</p>
      </Col>
      <Col span={24}>
        <h2 className="manrope f-20 w-700 black-085">{selectedData?.title}</h2>
        <Row gutter={[16, 16]} className="j-start-a-start">
          {selectedData?.features.map((feature, index) => (
            <Col xs={12} sm={8} md={8} lg={8} className="justify-in-center">
              <Card className="offer-card" bordered={false}
                cover={
                  feature.model ?
                    <div className="__model-container">
                      <ModelViewer class='__model'
                        poster={feature.poster}
                        src={feature.src}
                      />
                    </div> :
                    <img className="offer-img-size" src={feature?.image} />}
              >
                <h6 className="manrope f-16 w-700 black-085 text-center mt-16 justify-in-center">
                  {feature?.title}
                  {feature.beta &&
                    <span className="beta-bg-tag ml-12">BETA</span>}

                </h6>
                <p className="manrope f-14 w-500 lh-22 black-095 text-center">{feature?.subtext}</p>
              </Card>
            </Col>
          ))}
        </Row>
        {selectedData?.extra_features?.length > 0 &&
          <Row gutter={[16, 16]} className="j-start-a-start">
            {selectedData?.extra_features?.map((feature, index) => (
              <Col xs={6} sm={4} md={4} lg={4} className="justify-in-center">
                <Card className="offer-card" bordered={false}>
                  <img src={feature?.image} className="extra-offer-img-size" />
                  <h6 className="manrope f-16 w-700 black-085 text-center mt-16 justify-in-center">
                    {feature?.title}
                  </h6>
                </Card>
              </Col>
            ))}
          </Row>}
      </Col>
    </Row>

  </Modal>)
}

export default WhatYouGet;